export default {
  forgotPassword: "Forgot password",
  backToSignIn: "Back to Sign in",
  createTemplate: "Create template",
  updateTemplate: "Update template",
  createPrivateTemplate: "Create private template",
  updatePrivateTemplate: "Update private template",
  createPublicTemplate: "Create public template",
  updatePublicTemplate: "Update public template",
  createPageFromScratch: "Create a Page From Scratch",
  useDefaultOutputView: "Use Default Output View",
};
